export default "__VITE_ASSET__5431c10c__"